import { render } from "./FrangesEtCouronnes.vue?vue&type=template&id=2d23ba00&scoped=true"
import script from "./FrangesEtCouronnes.vue?vue&type=script&lang=js"
export * from "./FrangesEtCouronnes.vue?vue&type=script&lang=js"

import "./FrangesEtCouronnes.vue?vue&type=style&index=0&id=2d23ba00&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d23ba00"]])

export default __exports__